import { DefaultState, Filters } from 'store/types';

export const SET_RESERVATION_TABLE_FILTERS = "SET_RESERVATION_TABLE_FILTERS";

export type ReservationTableFiltersState = DefaultState & {
  contents: Filters;
  exists: boolean;
};

interface SetReservationTableFilters {
  type: typeof SET_RESERVATION_TABLE_FILTERS;
  contents: Filters;
  exists: boolean;
}

export type ReservationTableFiltersActionTypes = SetReservationTableFilters;
